import { createFileRoute } from "@tanstack/react-router";
import { Banners } from "@/components/Banners";

function RouteComponent() {
  return <Banners />;
}

export const Route = createFileRoute("/_authenticated/banners/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
